/**
 * Implements AutoSuggest Factory for cities for tcomb-form
 */
import React from  'react';
import { connect } from 'react-redux';
import Autosuggest from 'react-autosuggest';
import t from 'tcomb-form';
import { loadCitySuggestions }  from '../actions/geoActions';

class CityAutosuggest extends React.Component {
  state = {
    value: '',
    city: {
      id: '',
      label: '',
      coords: []
    },
    suggestions: []
  };

  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps) {
  }

  componentWillMount() {
    if(this.props.value) {
      this.setState({
        city: this.props.value,
        value: this.props.value.label
      });
    }
  }

  renderSuggestion = (suggestion, { value, valueBeforeUpDown}) => {
    return <span>{suggestion.label}</span>;
  }

  shouldRenderSuggestions = (value) => {
    if (value) {
      return value.trim().length > 2;
    }
    return false;
  };


  onSuggestionsFetchRequested = ({ value }) => {
    this.props.loadCitySuggestions(value);
  }

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  getSuggestionValue = (suggestion) => {
    return suggestion.label;
  }

  onInputChange = (e, { newValue, method}) => {
    this.setState({ value: newValue});
  }

  onSuggestionSelected = (event, { suggestion, suggestionValue, sectionIndex, method }) => {
    this.props.onChange(suggestion.id);
  }

  render() {
    const { value } = this.state;
    const { attrs, citySuggestions } = this.props;
    const suggestions = citySuggestions.results;
    const inputProps = {
      ...attrs,
      value: value || '',
      onChange: this.onInputChange
    };

    let loading = '';
    /*
     * Uncomment this block to enable in field loading animation. [MN]
     *
     * if (citySuggestions.isLoading) {
     *   loading = <span style={{ margin: 'auto', zIndex: 1000, position: 'absolute', right: 0, top: 0, bottom: 0,  height: '24px', width: '24px', color: '#ec052f' }}>
     *               <i className="fa fa-hourglass fa-spin"></i>
     *             </span>
     * }
     *
     */

    return (
      <div style={{ position: 'relative' }}>
      {loading}
       <Autosuggest suggestions={suggestions}
                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                    getSuggestionValue={this.getSuggestionValue}
                    renderSuggestion={this.renderSuggestion}
                    shouldRenderSuggestions={this.shouldRenderSuggestions}
                    onSuggestionSelected={this.onSuggestionSelected}
                    inputProps={inputProps} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return state;
};

CityAutosuggest = connect(
  mapStateToProps,
  { loadCitySuggestions }
)(CityAutosuggest);

function renderInput(locals) {
  return (
    <CityAutosuggest attrs={locals.attrs} onChange={locals.onChange} value={locals.value} />
  );
}

const cityAutosuggestTemplate = t.form.Form.templates.textbox.clone({ renderInput });

class CityAutosuggestFactory extends t.form.Textbox {

  getTemplate() {
    return cityAutosuggestTemplate;
  }

}

export default CityAutosuggestFactory;



// WEBPACK FOOTER //
// ./src/components/CityAutosuggest.jsx